import React from "react";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import useAppointments from "../../store/appointments/appointmentsContext";
import MoonLoader from "react-spinners/MoonLoader";
import { COLORS } from "../../config";
import AppointmentCalendar from "../../components/Calendar/AppointmentCalendar";
import useApp from "../../store/app/appContext";
import axios from "axios";

function AppointmentsDetails() {
  const { getPatientAppointments, getPartnerAppointments } = useAppointments();
  const [isLoading, setIsLoading] = React.useState(true);
  const [allAppointments, setAllAppointments] = React.useState([]);

  const {
    appState: { user, userAccount },
  } = useApp();

  React.useEffect(() => {
    let fetchAppointments;
    let source = axios.CancelToken.source();
    if (userAccount.isPartner) fetchAppointments = getPartnerAppointments;
    if (userAccount.isPatient) fetchAppointments = getPatientAppointments;
    if (typeof fetchAppointments === "function") {
      fetchAppointments(source).then((res) => {
        let appointments = res?.data?.data;
        let scheduled = [];
        appointments &&
          appointments.forEach((appointment) => {
            scheduled.push({
              start: moment(appointment.startTime).toDate(),
              end: moment(appointment.endTime).toDate(),
              name: userAccount.isPartner ? appointment.patientName : appointment.partnerName,
              clinic: appointment.clinic,
              id: appointment.appointment_id,
              status: appointment.status,
              profile_pic: appointment.patientProfilePic
            });
          });
        setAllAppointments(scheduled);
        setIsLoading(false);
      });
    }

    return () => {
      source.cancel();
    };
  }, [userAccount]);

  if (isLoading) {
    return (
      <div className={`flex flex-col items-center content-center`}>
        <div className="pt-4 text-4xl text-secondary mr-auto">
          My Appointments
        </div>
        <div className="flex justify-around min-h-170 pt-16">
          <MoonLoader color={COLORS.colorPrimary} />
        </div>
      </div>
    );
  }
  return <AppointmentCalendar isLoading={isLoading} events={allAppointments} />;
}

export default AppointmentsDetails;
